import objectifyForm from 'utils/objectifyForm';

const RedrawDataToPost = ( { uuid, member } ) => {
  let layoutOptions = objectifyForm($(`#form_${uuid}`));
  let layoutOptionsAdminPanel = objectifyForm($("#admin_panel_form"));
  for (let key in layoutOptionsAdminPanel) { layoutOptions[key] = layoutOptionsAdminPanel[key];}

  let dataToPost = Object.assign({ layout: layoutOptions, authenticity_token: $('meta[name=csrf-token]').attr('content') }, window.dielineOptions);

  // Combo guest items redraw against the guest drawing's URL but their dieline
  // options must be resolved server-side from the host's options. Hand the
  // server enough context (host_drawing_id + global combo state) to do that;
  // the matching DrawingComboRelation is recovered from
  // (host_drawing_id, URL drawing id) on the server, no need to pass it.
  if (member && member.is_combo_guest) {
    dataToPost.host_drawing_id = member.host_drawing_id;
    if (window.layoutComboState) {
      Object.assign(dataToPost, window.layoutComboState);
    }
  }

  return dataToPost;
}

export default RedrawDataToPost;
